import React, { useEffect, useState } from 'react';

import { useMyTasks } from 'hooks/UseMyTasks';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { Link } from 'react-router-dom';

import { getInstallerStatusbarData } from 'utils/InstallerUtils';
import { getLexikonUrl, getMyDataPath } from 'utils/UrlUtil';

import './css/HomePageHeaderSubLinks.sass';

const TWO_DIGIT = 100;

export const HomePageHeaderSubLink = ({ link, name, closeMenu, params, installer }) => {
  const isMyData = getMyDataPath() === link;
  const { newTaskCount } = useMyTasks({ skip: !isMyData });
  const [shouldExtend, setShouldExtend] = useState(false);

  useEffect(() => {
    if (!installer || getMyDataPath() !== link) return;
    const installerDataResponse = getInstallerStatusbarData(installer);
    const shouldExtendEntry =
      installerDataResponse.gasEntry?.shouldExtend ||
      installerDataResponse.energyEntry?.shouldExtend ||
      Boolean(newTaskCount);
    setShouldExtend(shouldExtendEntry);
  }, [installer, link, newTaskCount]);

  const prepareLocation = () => ({
    exact: 'false',
    to: {
      pathname: link,
      search: qs.stringify(params),
      state: params,
      key: Math.floor(Math.random() * TWO_DIGIT),
    },
  });

  const location = prepareLocation();

  return (
    <button
      type="button"
      className="sublink first-level"
      onClick={() => {
        const isLexikon = link.includes('lexikon');
        if (isLexikon) {
          window.location.assign(getLexikonUrl());
        }
        if (closeMenu) {
          closeMenu();
        }
      }}>
      <Link {...location}>
        <div className="homepage-header-sublink-text-wrapper">
          <div>{name}</div>
          {shouldExtend ? <div className="sublink-red">(!)</div> : null}
        </div>
      </Link>
    </button>
  );
};
HomePageHeaderSubLink.propTypes = {
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  closeMenu: PropTypes.func,
  params: PropTypes.object,
  installer: PropTypes.object,
};
HomePageHeaderSubLink.defaultProps = {
  closeMenu: () => {},
  params: {},
  installer: {},
};
